import { Fragment } from 'react/jsx-runtime';
import { Outlet } from 'react-router-dom';
import Header from '../ui/Header';
import Footer from '../ui/Footer';

interface MainLayoutProps {
  showFooter?: boolean;
}

export default function MainLayout({ showFooter = true }: MainLayoutProps) {
  return (
    <Fragment>
      <Header />
      <Outlet />
      {showFooter && <Footer />}
    </Fragment>
  );
}
